import { toNumber } from './to-number.js';
export const currencyStringToCents = (formattedCurrencyString) => {
    const asNumber = toNumber(formattedCurrencyString);
    return Math.ceil(asNumber * 100);
};
/** @deprecated - use `currencyStringToCents` instead (notice the uppercase `T` in `To`) */
export const currencyStringtoCents = currencyStringToCents;
//# sourceMappingURL=currency-string-to-cents.js.map